export default __webpack_public_path__ + "static/media/gato@3x.82cfd92e.png";